// Custom queries for User Manager

export const listUSERSWithOrganization = /* GraphQL */ `
  query ListUSERSWithOrganization(
    $filter: ModelUSERFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUSERS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        role
        organizationID
        status
        assignedVendors
        lastLoginAt
        lastActiveAt
        cognitoCreatedAt
        createdAt
        updatedAt
        userOrganization {
          id
          name
          type
          isAgency
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getORGANIZATIONWithClient = /* GraphQL */ `
  query GetORGANIZATIONWithClient($id: ID!) {
    getORGANIZATION(id: $id) {
      id
      name
      type
      isAgency
      __typename
    }
  }
`;

export const getCLIENTByOrganization = /* GraphQL */ `
  query GetCLIENTByOrganization($organizationID: ID!) {
    clientByOrganizationID(organizationID: $organizationID) {
      items {
        id
        organizationID
        agencyOrganizationID
        clientOrganization {
          id
          name
          type
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const listCLIENTSWithOrganizations = /* GraphQL */ `
  query ListCLIENTSWithOrganizations(
    $filter: ModelCLIENTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCLIENTS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationID
        agencyOrganizationID
        mode
        clientOrganization {
          id
          name
          type
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;